import httpManager from "@/app/shared/utils/httpManager";

/**
 * Actualiza un alias "Enviar como" de un canal de correo.
 *
 * @param {number} channelCustomerId - ID del identificador de canal.
 * @param {number} id - ID del alias a actualizar.
 * @param {Object} data - Datos a actualizar.
 * @param {string} data.email - Nueva dirección de correo electrónico.
 * @returns {Promise<Object>} Datos del alias actualizado.
 */
export default async function (channelCustomerId, id, data) {
  const response = await httpManager.put(
    `/channels/channel-customer/${channelCustomerId}/send-as-aliases/${id}/`,
    data
  );
  return response?.data;
}
